import { userPreferences } from "../../../react/context/bryntumContext.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import { StringHelper } from "@bryntum/schedulerpro";
import SettingsTabBase from "./SettingsTabBase.jsx";
import { BUDGET_FIELDS_CONFIG } from "../../../other/constants/TaskBudget/taskBudgetViewColumnsData.js";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";

export default class SwivuSettingsBudgetTab extends SettingsTabBase {
  static get $name() {
    return "BudgetHoverSettingsTab"
  }

  static get type() {
    return "budgethoversettingstab"
  }

  static get configurable() {
    return {
      title: "Budget Settings",
      cls: "p-[1em] flex-col gap-[1em]",
      defaults: {
        labelWidth: "7em",
      },
      items: {
        budgetHoverGrid: {
          features: {
            cellMenu: false,
            rowReorderExtend: false,
            sort: false,
            group: false,
            headerMenu: false,
            rowReorder: {
              showGrip: true
            }
          },
          type: WIDGET_KEYS.swivuPreferenceStyleGrid,
          width: "100%",
          flex: "1 1 0%",
          columns: [
            {
              id: "budget-field",
              field: "budgetFieldTitle",
              text: "Budget Hover",
              editor: false,
              renderer: ({ row, value }) => {
                return {
                  style: row.dataIndex < 6 ? { color: "#da924c" } : "",
                  text: value
                }
              },
            },
          ],
          listeners: {
            gridRowDrop: "up.onGridRowDrop"
          }
        },
        budgetLabelCombo: {
          type: "combo",
          label: "Budget Label",
          items: [
            { budgetField: "notDisplayed", budgetFieldTitle: "Not Displayed" },
            ...BUDGET_FIELDS_CONFIG
          ],
          onChange: "up.onBudgetFieldChange",
          displayField: "budgetFieldTitle",
          valueField: "budgetField",
          swivuPrefKey: PERSISTENCE_STATE_KEYS.budgetLabel
        },
        budgetActualDaysCombo: {
          type: "combo",
          label: "Actual Days",
          valueField: "id",
          onChange: "up.onBudgetFieldChange",
          displayField: "description",
          multiSelect: true,
          swivuPrefKey: PERSISTENCE_STATE_KEYS.budgetActualDays,
          placeholder: "Resource Types included when summing Actual Days"
        },
      }
    }
  }

  loadRecord(record, context, otherParams) {
    super.loadRecord(record, context, otherParams);
    Object.assign(this, context, otherParams);
    if (otherParams.isFirstShow) {
      const { budgetHoverGrid, budgetLabelCombo, budgetActualDaysCombo } = this.widgetMap;
      budgetHoverGrid.store.data = this.getStoreData();
      budgetLabelCombo.value = userPreferences.getSetting(PERSISTENCE_STATE_KEYS.budgetLabel, "notDisplayed", true);
      budgetActualDaysCombo.store = context.project.resourceTypeStore
      budgetActualDaysCombo.value = StringHelper.safeJsonParse(userPreferences.getSetting(PERSISTENCE_STATE_KEYS.budgetActualDays, null, true)) ?? [];
    }
  }

  getStoreData() {
    const budgetHoverOrder = StringHelper.safeJsonParse(userPreferences.getSetting(PERSISTENCE_STATE_KEYS.budgetHoverOrder, null, true))
    if (budgetHoverOrder?.length) {
      const itemsToMove = budgetHoverOrder.reduce((prevState, currentItem) => {
        const budgetItem = BUDGET_FIELDS_CONFIG.find((item) => item.budgetField === currentItem);
        // If budget field is removed, but exists in budget hover preference
        if (budgetItem) prevState.push(budgetItem);
        return prevState;
      }, [])
      const remainingItems = BUDGET_FIELDS_CONFIG.filter((item) => !budgetHoverOrder.includes(item.budgetField));
      return [...itemsToMove, ...remainingItems];
    }
    return BUDGET_FIELDS_CONFIG;
  }

  onGridRowDrop({ source }) {
    const hoverRecords = source.store.records.slice(0, 6).map((item) => item.budgetField);
    userPreferences.updateSetting(PERSISTENCE_STATE_KEYS.budgetHoverOrder, StringHelper.safeJsonStringify(hoverRecords), true)
  }

  onBudgetFieldChange({ value, userAction, source }) {
    if (userAction) {
      const valueToSave = typeof value === "string" ? value: StringHelper.safeJsonStringify(value);
      userPreferences.updateSetting(source.swivuPrefKey, valueToSave, true);
    }
  }
}
SwivuSettingsBudgetTab.initClass();
